/**
 * Art Lembrar: Presente Surpresa no carrinho
 * Ficheiro: assets/al-presente-surpresa.js
 * Carregado em todas as paginas por snippets/cart-icon-component.liquid
 *
 * 1. Mete o "Presente Surpresa" no carrinho quando o total chega a 70 €
 *    (DEPOIS dos codigos de desconto: cart.total_price) e tira-o quando desce abaixo.
 *    Fica a 0 € pelo desconto automatico "🎁 Ganhaste um presente surpresa".
 * 2. Evita mexidas ao mesmo tempo que a pessoa:
 *    - o presente so se ajusta quando a pessoa para de mexer no carrinho (IDLE_MS);
 *    - enquanto o presente entra/sai, o carrinho fica bloqueado a toques (como o tema faz);
 *    - os pedidos do tema a /cart/change passam a ir pela CHAVE do artigo (lida do ecra no
 *      momento do pedido), MAS so quando essa chave e unica no carrinho. Quando a Shopify
 *      parte a mesma peca em duas linhas (desconto "compre X ganhe Y"), as duas tem a mesma
 *      chave; ai mantem-se a posicao (line), senao a quantidade ia para a linha errada.
 * 3. Rapidez: aproveita a resposta do proprio carrinho (sem pedir /cart.js outra vez) e pede
 *    o carrinho ja desenhado junto com a entrada/saida do presente (sem segundo pedido).
 * 4. Ao carregar em "Finalizar compra", confirma primeiro o presente e so depois segue.
 * 5. No drawer, troca a barra de portes pela barra com dois marcos (40 € e 70 €),
 *    que vem desenhada em Liquid em snippets/al-presente-surpresa.liquid.
 * 6. Esconde o nome do desconto por baixo dos artigos no carrinho.
 *    Se mudares o nome do desconto na Shopify, muda tambem DISCOUNT_TITLES.
 *
 * Para mudar o valor: GOAL aqui e al_g_goal no snippet (em centimos).
 */
import { CartAddEvent } from '@theme/events';

if (!window.__alGift) {
  window.__alGift = true;

  const GIFT_VARIANT = 57450884202874;
  const GOAL = 7000;
  const IDLE_MS = 400; // espera depois do ultimo toque no carrinho antes de mexer no presente
  const AFTER_CHANGE_MS = 120; // espera depois de uma alteracao do carrinho antes de verificar
  const DISCOUNT_TITLES = ['🎁 Ganhaste um presente surpresa', 'Presente Surpresa acima de 70€'];
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const baseFetch = window.fetch.bind(window);
  const own = (init) => Object.assign({}, init || {}, { __alGift: true });

  let running = null;
  let again = false;
  let timer = 0;
  let pending = 0; // pedidos do tema ao carrinho ainda a caminho
  let lastTouch = 0; // ultimo toque da pessoa nas quantidades do carrinho
  let lockTimer = 0;
  let freshCart = null; // carrinho devolvido pelo ultimo pedido do tema (evita pedir /cart.js)

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(() => sync(), ms);
  }

  function getCart() {
    return baseFetch('/cart.js', own({ headers: { Accept: 'application/json' } })).then((r) => r.json());
  }

  function cartSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((c) => ids.add(c.dataset.sectionId));
    return Array.from(ids);
  }

  /* Bloqueia toques no carrinho enquanto o presente entra/sai e o carrinho volta a desenhar */
  function lockCart(on) {
    clearTimeout(lockTimer);
    document.querySelectorAll('cart-items-component').forEach((c) => c.classList.toggle('cart-items-disabled', on));
    if (on) lockTimer = setTimeout(() => lockCart(false), 2500); // seguranca
  }

  function refresh(itemCount, sections) {
    if (!document.querySelector('cart-drawer-component') && /\/cart\/?$/.test(location.pathname)) {
      location.reload();
      return;
    }
    const data = { source: 'al-gift', itemCount: itemCount };
    if (sections) data.sections = sections;
    document.dispatchEvent(new CartAddEvent({}, 'al-gift', data));
    // desbloqueia quando o carrinho voltar a ser desenhado (ou ao fim de pouco tempo)
    const comp = document.querySelector('cart-items-component');
    if (!comp) return lockCart(false);
    const mo = new MutationObserver(() => {
      mo.disconnect();
      setTimeout(() => lockCart(false), 120);
    });
    mo.observe(comp, { childList: true, subtree: true });
    setTimeout(() => { mo.disconnect(); lockCart(false); }, 1500);
  }

  /* Acerta o presente uma vez. Devolve true se mudou alguma coisa no carrinho. */
  async function syncOnce(opts) {
    let cart = null;
    if (freshCart && pending === 0 && !(opts && opts.force)) cart = freshCart;
    freshCart = null;
    if (!cart) cart = await getCart();

    const lines = (cart.items || []).filter((i) => i.variant_id === GIFT_VARIANT);
    const giftQty = lines.reduce((s, i) => s + i.quantity, 0);
    const giftTotal = lines.reduce((s, i) => s + i.final_line_price, 0);
    const base = cart.total_price - giftTotal;
    const want = cart.item_count - giftQty > 0 && base >= GOAL;

    let url = null;
    let body = null;
    let newCount = cart.item_count;
    if (want && !lines.length) {
      url = '/cart/add.js';
      body = { items: [{ id: GIFT_VARIANT, quantity: 1 }] };
      newCount += 1;
    } else if (!want && lines.length) {
      url = '/cart/update.js';
      body = { updates: {} };
      lines.forEach((l) => { body.updates[l.key] = 0; });
      newCount -= giftQty;
    } else if (want && giftQty > 1) {
      url = '/cart/update.js';
      body = { updates: {} };
      lines.forEach((l, i) => { body.updates[l.key] = i === 0 ? 1 : 0; });
      newCount -= giftQty - 1;
    }
    if (!url) return false;

    const silent = opts && opts.silent;
    const ids = silent ? [] : cartSectionIds();
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }
    if (!silent) lockCart(true);
    const res = await baseFetch(url, own({ method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) }));
    if (!res.ok) {
      lockCart(false);
      return false;
    }
    if (!silent) {
      let sections = null;
      try {
        const json = await res.json();
        sections = json && json.sections ? json.sections : null;
        if (typeof json.item_count === 'number') newCount = json.item_count;
      } catch (_) {}
      refresh(newCount, sections);
    }
    return true;
  }

  /* Corre o acerto sem nunca ter dois ao mesmo tempo. Devolve uma promessa.
     Sem opts.force, espera que a pessoa pare de mexer no carrinho. */
  function sync(opts) {
    clearTimeout(timer);
    const force = opts && opts.force;
    if (!force && (pending > 0 || Date.now() - lastTouch < IDLE_MS)) {
      schedule(120);
      return Promise.resolve(false);
    }
    if (running) {
      again = true;
      return running;
    }
    running = (async () => {
      let changed = false;
      try {
        // nunca mexer enquanto ha uma alteracao do tema a caminho
        for (let i = 0; i < 40 && pending > 0; i++) await sleep(100);
        do {
          again = false;
          changed = (await syncOnce(opts)) || changed;
        } while (again);
      } catch (_) {
        lockCart(false);
      }
      running = null;
      return changed;
    })();
    return running;
  }

  /* Regista toques nas quantidades / lixo do carrinho */
  function touch(e) {
    const t = e.target && e.target.closest && e.target.closest('cart-items-component .cart-items__quantity, cart-items-component .cart-items__remove');
    if (t) lastTouch = Date.now();
  }
  ['pointerdown', 'focusin', 'input', 'keydown', 'click'].forEach((t) => document.addEventListener(t, touch, true));

  /* Troca "line" (posicao) pela chave do artigo que esta nessa posicao NO ECRA, no momento do
     pedido, mas so se essa chave for unica (pecas partidas em duas linhas partilham a chave). */
  function lineToKey(url, init) {
    if (!/\/cart\/change(\.js)?(\?|$)/.test(url) || !init || typeof init.body !== 'string') return init;
    let body;
    try { body = JSON.parse(init.body); } catch (_) { return init; }
    if (!body || body.id || !body.line) return init;
    const line = String(body.line);
    let row = null;
    const inp = document.querySelector('cart-items-component input[data-cart-line="' + line + '"]');
    if (inp) row = inp.closest('tr[data-key]');
    if (!row) {
      const rm = document.querySelector('cart-items-component [on\\:click="/onLineItemRemove/' + line + '"]');
      if (rm) row = rm.closest('tr[data-key]');
    }
    const key = row && row.getAttribute('data-key');
    if (!key) return init;
    const comp = row.closest('cart-items-component') || document;
    const same = Array.from(comp.querySelectorAll('tr[data-key]')).filter((r) => r.getAttribute('data-key') === key);
    if (same.length !== 1) return init; // chave repetida: fica a posicao
    delete body.line;
    body.id = key;
    return Object.assign({}, init, { body: JSON.stringify(body) });
  }

  /* Qualquer mudanca no carrinho (adicionar, quantidades, remover, codigos) volta a verificar */
  window.fetch = function (input, init) {
    if (init && init.__alGift) return baseFetch(input, init);
    let url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || String(input);
    } catch (_) {}
    const isCart = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    if (!isCart) return baseFetch(input, init);

    init = lineToKey(url, init);
    pending++;
    freshCart = null;
    const p = baseFetch(input, init);
    p.then((r) => {
      if (!r.ok) return;
      // guarda o carrinho que veio na resposta (change/update devolvem o carrinho inteiro)
      r.clone().json().then((j) => {
        if (j && Array.isArray(j.items) && typeof j.total_price === 'number' && typeof j.item_count === 'number') {
          freshCart = j;
        }
      }).catch(() => {});
      schedule(AFTER_CHANGE_MS);
    })
      .catch(() => {})
      .finally(() => { pending = Math.max(0, pending - 1); });
    return p;
  };

  document.addEventListener('cart:update', (e) => {
    const d = e && e.detail;
    if (d && (d.sourceId === 'al-gift' || (d.data && d.data.source === 'al-gift'))) return;
    schedule(AFTER_CHANGE_MS);
  });

  schedule(300);

  /* ===== Finalizar compra: acerta o presente antes de ir para o checkout ===== */
  let passThrough = false;
  window.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (passThrough || !(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      submitter.setAttribute('aria-busy', 'true');
      submitter.style.opacity = '0.7';

      // Espera que qualquer mudanca de quantidade ainda a caminho termine
      setTimeout(async () => {
        try {
          await sync({ silent: true, force: true });
        } catch (_) {}
        submitter.removeAttribute('aria-busy');
        submitter.style.opacity = '';
        const f = document.getElementById('cart-form') || form;
        const btn = document.querySelector('[name="checkout"][form="cart-form"], #checkout') || submitter;
        passThrough = true;
        try {
          if (typeof f.requestSubmit === 'function' && btn.isConnected) f.requestSubmit(btn);
          else window.location.href = '/checkout';
        } catch (_) {
          window.location.href = '/checkout';
        } finally {
          passThrough = false;
        }
      }, 350);
    },
    true
  );

  /* Tira o nome do desconto do presente de baixo dos artigos */
  function hideDiscountTitle() {
    document.querySelectorAll('.cart-items__details ul.list-unstyled li').forEach((li) => {
      if (DISCOUNT_TITLES.indexOf(li.textContent.trim()) === -1) return;
      const ul = li.parentElement;
      li.remove();
      if (ul && !ul.children.length) ul.remove();
    });
  }

  /* ===== Barra com dois marcos no drawer ===== */
  function paint() {
    hideDiscountTitle();
    const st = document.querySelector('.al-drawer [data-al-gift-state]');
    const bar = document.querySelector('.al-drawer .al-ship');
    if (!st || !bar) return;
    const sig = st.getAttribute('data-sig');
    if (bar.getAttribute('data-al-g') === sig && bar.querySelector('.al-gtrack')) return;

    const msgSrc = st.querySelector('[data-al-g-msg]');
    const trkSrc = st.querySelector('[data-al-g-track] .al-gtrack');
    const msg = bar.querySelector('.al-ship__msg');
    const trk = bar.querySelector('.al-ship__track');
    if (msgSrc && msg) msg.innerHTML = msgSrc.innerHTML;
    if (trkSrc && trk) trk.replaceWith(trkSrc.cloneNode(true));

    ['low', 'mid', 'near', 'done'].forEach((s) => bar.classList.remove('al-ship--' + s));
    bar.classList.add('al-ship--g');
    bar.setAttribute('data-al-g', sig);
  }

  paint();
  document.addEventListener('DOMContentLoaded', paint);
  new MutationObserver(paint).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-sig'] });
}
